import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from "react-intl";
import moment from 'moment';

//Enums
import { TypeObjectMap, GeofenceRadiusValues, TypeLayer } from 'Components/Map/providers/enums';
import { useGeocoder } from 'Core/hooks';

//Components

import TagsManage from 'Modules/.common/components/TagsManage';
import InputRadius from 'Components/Map/components/InputRadius';
import { NotificationManager } from 'Components/Notifications';
import FromToMap from 'Components/Map/components/FromToMap';
import { TimeFrame } from '@gpstrackit/gtc-react-controls';
import { Loading, Form, Pill } from 'Components';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

//Actions
import {
    selectCreateClickMapType,
    pointersCreated,
    addPointers,
    setLatLng,
    zoomPointOnMap
} from 'Redux/actions';
import {
    realtimeMapsVicinityToolSearchReadings,
    vicinityToolSetField,
    vicinityToolReset,
} from '../../redux/slice';

//Styles
import './style.scss'

//define the area in metters to the circle and square objects
const maximunAreaCircle = 1500;
const maximunAreaSquare = 2500;
const VicinityToolSettings = (props) => {
    const { mapRef, formRef, timeFrame, fromToMapRef } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Hooks
    const [onGetGeocoder, address, setAddress] = useGeocoder();

    //Variables
    const objectOnMap = 'mapObject_01';
    const defaulRadius = 15.24;

    const selectTypes = [
        { name: messages['realtimemaps_address'], id: "ADDRESS", showDefault: true, color: '#66BB6A' },
        { name: messages['realtimemaps_useMapClick'], id: "MAP_CLICK", showDefault: true, color: '#66BB6A' },
        { name: messages['realtimemaps_unit'], id: "UNITS", showDefault: true, color: '#66BB6A' }
    ];

    //Redux States
    const { loading, shape, group, dataRange, startingLocation, selectedUnit, step, coordinates, result, center, idFromTo, radius, initialShape, error, inicialState } = useSelector(state => state.realtimeMapsVicinityTool);
    const { pointersCreated: newPoint } = useSelector((state) => state.realtimeMapRedux);
    const dateformat = useSelector(state => state.securityRedux.user.dateformat);
    const pointOnMap = useSelector(state => state.realtimeMapRedux.pointOnMap);

    //Local States
    const [createShape, setCreateShape] = useState(false);
    const [restart, setRestart] = useState(0);

    //declare the objects to shape at geoform on maps
    const typeGeo = [
        { id: 1, shape: 'polygon', type: TypeObjectMap.Polygon, name: messages['mapLandmarkCreateEditLandmark_polygon'], maxPoints: 50 },
        { id: 2, shape: 'circle', type: TypeObjectMap.Circle, name: messages['mapLandmarkCreateEditLandmark_circle'], maxPoints: 0 },
        { id: 3, shape: 'square', type: TypeObjectMap.Square, name: messages['mapLandmarkCreateEditLandmark_square'], maxPoints: 0 },
    ];

    const pillItemClick = (item) => {
        dispatch(selectCreateClickMapType(item.type, item.maxPoints));
        dispatch(addPointers([]));
        setAddress(null);
        dispatch(setLatLng(null));
        dispatch(pointersCreated(false));
        dispatch(vicinityToolSetField({ radius: null, shape: item, group: [] }))
        if (fromToMapRef?.current?.clearInputSearchMap) {
            fromToMapRef?.current?.clearInputSearchMap();
        }
    }

    const onMapClickCircle = useCallback((latLng, idFromTo, radius) => {
        const position = { lat: latLng.lat, lng: latLng.lng };
        mapRef.current.addCircleOnMapToCreate(position, onUpdateList, idFromTo, objectOnMap, radius, maximunAreaCircle);
        dispatch(pointersCreated(true));
    });


    const onMapClickSquare = useCallback((latLng, idFromTo, radiusObject) => {
        //testing the object before the add the square
        const objectExist = mapRef.current.getObject(TypeObjectMap.Square, radiusObject) || null
        if (objectExist) return

        mapRef.current.addSquareOnMapToCreate(latLng, idFromTo, radiusObject, radius || defaulRadius, null, onUpdateList, maximunAreaSquare / 2);
        dispatch(pointersCreated(true));
    })

    const onGetPoint = useCallback((position, idFromTo) => {
        dispatch(vicinityToolSetField({ idFromTo: idFromTo }))
        if (shape?.type === TypeObjectMap.Circle) {
            mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
            if (position && position.length > 0) {
                dispatch(vicinityToolSetField({
                    center: { lat: position[0]?.lat, lng: position[0]?.lng }
                }))
                onMapClickCircle({ lat: position[0]?.lat, lng: position[0]?.lng }, idFromTo, radius || defaulRadius);
            }
        } else if (shape?.type === TypeObjectMap.Square) {
            mapRef?.current?.removeLayer(TypeLayer.SquareCreate);
            if (position && position.length > 0) {
                dispatch(vicinityToolSetField({
                    center: { lat: position[0]?.lat, lng: position[0]?.lng }
                }))
                onMapClickSquare({ lat: position[0]?.lat, lng: position[0]?.lng }, idFromTo, objectOnMap);
            }
        }
    });

    const computePoint = (lat, lng, radius, angle) => {
        var angleRad = angle * Math.PI / 180;

        var latRadians = lat * Math.PI / 180;
        var lngRadians = lng * Math.PI / 180;
        var earthRadius = 6371000;

        var pointLat = Math.asin(Math.sin(latRadians) * Math.cos(radius / earthRadius) +
            Math.cos(latRadians) * Math.sin(radius / earthRadius) * Math.cos(angleRad));
        var pointLng = lngRadians + Math.atan2(Math.sin(angleRad) * Math.sin(radius / earthRadius) * Math.cos(latRadians),
            Math.cos(radius / earthRadius) - Math.sin(latRadians) * Math.sin(pointLat));

        pointLat = pointLat * 180 / Math.PI;
        pointLng = pointLng * 180 / Math.PI;

        return { latitude: pointLat, longitude: pointLng };
    }

    const getPolygonCoordinatesFromCircle = (lat, lng, radius) => {
        var numPoints = 12;
        var angleStep = 360 / numPoints;
        var polygonCoords = [];

        for (var i = 0; i < numPoints; i++) {
            var angle = i * angleStep;
            var point = computePoint(lat, lng, radius, angle);
            polygonCoords.push(point);
        }

        polygonCoords.push(polygonCoords[0]);

        return polygonCoords;
    }

    const onChangeRadius = useCallback((radius) => {
        dispatch(vicinityToolSetField({ radius: radius }))
        if (shape.type === TypeObjectMap.Circle) {
            mapRef?.current?.updateCirclePoint(objectOnMap, null, radius, true);
        } else {
            //update the square object for Diagonally distance
            mapRef.current.setUpdateSquareDiagonally(radius);
        }
    });

    const onUpdateList = (distanceInMetters) => {
        let value = Math.round(distanceInMetters) || null
        dispatch(vicinityToolSetField({ radius: value }))
    }

    const onSubmit = () => {

        if (!shape) return;

        if ((shape.type === TypeObjectMap.Circle || shape.type === TypeObjectMap.Square) && !newPoint) {
            setCreateShape(true)
            return
        }

        let coordinates = [];
        let newCoordinates = [];

        let currentShape = "";
        if (shape?.type === TypeObjectMap.Circle) {
            let ccoordinates = mapRef?.current?.getCircleCoordinates();
            setCreateShape(ccoordinates ? true : false)
            dispatch(vicinityToolSetField({ coordinates: ccoordinates }))
            if (ccoordinates) {
                const polygonCoords = getPolygonCoordinatesFromCircle(ccoordinates[0].latitude, ccoordinates[0].longitude, radius)
                coordinates = polygonCoords;
            }
            currentShape = "polygon";
        } else if (shape?.type === TypeObjectMap.Polygon) {
            const { coordinates: pcoordinates } = mapRef.current.getPolygonCoordinates();
            if ((pointOnMap?.id || selectedUnit?.id) && !pcoordinates?.length) {
                NotificationManager.warning(
                    messages['realtimemaps_vicinitytool_info_polygon'].replace('{maxPoints}', '50'),
                    messages['realtimemaps_vicinitytool_vicinity_tool'],
                    3000
                );
                return
            }
            if (pcoordinates && !pcoordinates?.length) {
                setCreateShape(true)
                return
            }

            if (pcoordinates && pcoordinates.length) {
                dispatch(vicinityToolSetField({ coordinates: pcoordinates }))
                coordinates = pcoordinates;
                newCoordinates = pcoordinates
            }

            let objectPolygon = mapRef.current.getObject(TypeObjectMap.Polygon, objectOnMap)
            if (objectPolygon) {
                let paths = objectPolygon.instance.getPath()
                const areaInSquareMeters = google.maps.geometry.spherical.computeArea(paths)
                const areaInSquareMiles = areaInSquareMeters * 3.861e-7;

                if (areaInSquareMiles > 4) {
                    NotificationManager.warning(
                        messages['realtimemaps_vicinitytool_error_polygon_area_error'],
                        messages['realtimemaps_vicinitytool_vicinity_tool'],
                        3000
                    );
                    return
                }
            }

            currentShape = "polygon";
            if (newCoordinates.length <= 3) {
                NotificationManager.warning(
                    messages['realtimemaps_vicinitytool_info_polygon'].replace('{maxPoints}', '50'),
                    messages['realtimemaps_vicinitytool_vicinity_tool'],
                    3000
                );
                return
            }
        } else if (shape?.type === TypeObjectMap.Square) {
            const objectSquare = mapRef.current.getObject(TypeObjectMap.Square, objectOnMap);

            if (!objectSquare) {
                setCreateShape(true)
                return
            }

            let newCoordinates = objectSquare?.coordinates || []
            dispatch(vicinityToolSetField({
                coordinates: newCoordinates
            }))

            currentShape = "polygon";
            coordinates = newCoordinates
        }

        if (coordinates?.length === 0) {
            setCreateShape(true)
            return
        }

        setCreateShape(false)
        let startDate = moment(timeFrame?.startDate)
        let endDate = moment(timeFrame?.endDate)
        if (startDate && endDate) {
            const rangeMinutes = endDate.diff(startDate, 'minutes')
            if (rangeMinutes > 720) {
                NotificationManager.error(
                    messages['realtimemaps_vicinitytool_message_max_12_hours'],
                    messages['realtimemaps_vicinitytool_vicinity_tool'],
                    3000
                );
                return
            }
        }

        dispatch(vicinityToolSetField({
            dataRange: {
                start: moment(timeFrame?.startDate).format(),
                end: moment(timeFrame?.endDate).format()
            }
        }))

        if ((shape?.type === TypeObjectMap.Circle || shape?.type === TypeObjectMap.Square) && radius < 40) {
            NotificationManager.warning(
                messages['realtimemaps_vicinitytool_error_radius'],
                messages['realtimemaps_vicinitytool_vicinity_tool'],
                3000
            );
            return
        }

        let payload = {
            coordinates,
            shape: currentShape,
            radius: shape?.type === TypeObjectMap.Circle || shape?.type === TypeObjectMap.Square ? Math.round(radius * 3.28084) || Math.round(defaulRadius * 3.28084) : 0,
            tagIds: group?.length ? group.map((item) => item.id) : [],
            dateRange: {
                start: moment.utc(timeFrame?.startDate).format(),
                end: moment.utc(timeFrame?.endDate?.seconds(59)).format()
            },
            limit: 100,
            offset: 0
        }

        dispatch(realtimeMapsVicinityToolSearchReadings(payload))
    }

    useEffect(() => {
        timeFrame.onChangeSelect({ id: "custom", label: messages['date_custom'] }, dataRange.start, dataRange.end)
        if (startingLocation) {
            let value = selectTypes.find((item) => item.id === startingLocation) || null
            fromToMapRef?.current?.setSelectType(value)
        }
        if (selectedUnit) {
            fromToMapRef?.current?.setSelectUnit(selectedUnit)
        }
    }, [])

    useEffect(() => {
        if (step === "settings" && initialShape && !result.length) {
            if (step === "settings" && coordinates.length && result.length === 0) {
                if (shape?.shape === "polygon") {
                    mapRef.current.showLayer(TypeLayer?.PolygonCreate, true);
                }
                if (shape?.shape === "circle") {
                    setTimeout(() => {
                        onMapClickCircle(center, idFromTo, radius);
                    }, 500)
                }
                if (shape?.shape === "square") {
                    setTimeout(() => {
                        onMapClickSquare(center, idFromTo, objectOnMap);
                    }, 500)
                }
            }
            vicinityToolSetField({ initialShape: false });
        }
        if (inicialState) {
            fromToMapRef?.current?.resetComponent();
            dispatch(vicinityToolReset());
        }
    }, [initialShape, inicialState])

    useEffect(() => {
        if (error) {
            if (error === "no data") {
                NotificationManager.success(
                    messages['realtimemaps_vicinitytool_no_data_availabled'],
                    messages['realtimemaps_vicinitytool_vicinity_tool'],
                    3000
                );
                if (shape?.shape === "circle") {
                    setTimeout(() => onMapClickCircle(center, idFromTo, radius), 500)
                } else if (shape?.shape === "square") {
                    setTimeout(() => onMapClickSquare(center, idFromTo, objectOnMap), 500)
                }
            } else if (error.includes("exceed 24 hours")) {
                NotificationManager.error(
                    messages['realtimemaps_vicinitytool_the_range_exceed'],
                    messages['realtimemaps_vicinitytool_vicinity_tool'],
                    3000
                );
            } else {
                NotificationManager.error(
                    messages['realtimemaps_vicinitytool_error_obtaining_data'],
                    messages['realtimemaps_vicinitytool_vicinity_tool'],
                    3000
                );
            }
            dispatch(vicinityToolReset({ error: null }))
        }
    }, [error])

    return (
        <div style={{ padding: 0 }}>
            <p style={{ marginTop: -10 }} className='text-muted'>
                {messages['realtimemaps_vicinitytool_message']}
            </p>
            <div style={{ height: '65vh', overflow: 'auto', paddingRight: 6 }}>
                <Form
                    ref={formRef}
                    onValidSubmit={onSubmit}
                >
                    {loading && <Loading overlay show />}
                    <div style={{ marginBottom: 12, paddingRight: 2 }}>
                        <Grid>
                            <label className="label-gtc-rc">{messages['realtimemaps_vicinitytool_shape']}</label>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                            spacing={1}
                            style={{ marginTop: 2, marginBottom: 10 }}
                        >
                            {
                                typeGeo.map((item) => {
                                    return (
                                        <Grid key={item.id} item xs>
                                            <Pill
                                                key={item.id}
                                                textField={'name'}
                                                item={item}
                                                outlined={item.id !== shape?.id}
                                                onClick={(item) => {
                                                    pillItemClick(item);
                                                    setTimeout(() => { setRestart(restart + 1) }, 500);
                                                    dispatch(vicinityToolSetField({ radius: 0, selectedUnit: null }));
                                                    fromToMapRef?.current?.setSelectUnit([]);
                                                }}
                                                style={{ border: '0', margin: '2px 0', width: '100%' }}
                                                label="pill-label-text"
                                                colorField="default"
                                                colorSelection={'66BB6A'}
                                            />
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                    </div>
                    {
                        shape &&
                        <>
                            <div style={{ marginBottom: 12 }}>
                                <Grid>
                                    <label className="label-gtc-rc">{messages['realtimemaps_vicinitytool_startinglocation']}</label>
                                </Grid>
                                <div className="vicinity-tool-fromtomap-container">
                                    {
                                        (shape?.type === TypeObjectMap.Circle || shape?.type === TypeObjectMap.Square) ? (
                                            <FromToMap
                                                id="starting-location"
                                                ref={fromToMapRef}
                                                noMapClick
                                                onGetAddress={(event) => {
                                                    onGetPoint(event, "vicinityTool01");
                                                }}
                                                onGetPosition={(position, id) => {
                                                    onGetPoint([position], id);
                                                }}
                                                onSelectSelectUnit={(unit) => {
                                                    dispatch(vicinityToolSetField({ selectedUnit: unit }))
                                                    onGetPoint([{
                                                        ...unit?.lastReading,
                                                        lat: unit?.lat,
                                                        lng: unit?.lng
                                                    }], 'vicinityTool01');
                                                }}
                                                onClear={() => {
                                                    mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                                                    mapRef?.current?.removeLayer(TypeLayer.SquareCreate);
                                                }}
                                                onClearMarker={() => {
                                                    mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
                                                    mapRef.current.removeMapObject("vicinityTool01", TypeObjectMap.Marker);
                                                }}
                                                messages={messages}
                                                required={true}
                                                getCoordinates
                                                pills
                                                restart={restart}
                                                maxPoints={shape.maxPoints}
                                                entities={["ADDRESS", "MAP_CLICK", "UNITS"]}
                                                onChange={(type) => {
                                                    dispatch(vicinityToolSetField({ startingLocation: type?.id, selectedUnit: null }));
                                                    fromToMapRef?.current?.setSelectUnit([]);
                                                    dispatch(zoomPointOnMap(null));
                                                    setCreateShape(false);
                                                }}
                                                automaticCleaner={false}
                                            />
                                        ) : (
                                            <FromToMap
                                                id="starting-location-by-polygon"
                                                ref={fromToMapRef}
                                                onSelectSelectUnit={(unit) => {
                                                    mapRef?.current?.centerPointOnMap(unit?.lat, unit?.lng, 11);
                                                    dispatch(vicinityToolSetField({ selectedUnit: unit }));
                                                }}
                                                messages={messages}
                                                createElements
                                                required={false}
                                                noMapClick
                                                pills
                                                isPolygon
                                                restart={restart}
                                                maxPoints={shape?.maxPoints}
                                                entities={["ADDRESS", "MAP_CLICK", "UNITS"]}
                                                onChange={(type) => {
                                                    dispatch(vicinityToolSetField({ startingLocation: type?.id, selectedUnit: null }));
                                                    fromToMapRef?.current?.setSelectUnit([]);
                                                    dispatch(zoomPointOnMap(null));
                                                    setCreateShape(false);
                                                }}
                                                automaticCleaner={false}
                                            />
                                        )
                                    }
                                </div>
                                {
                                    createShape
                                    &&
                                    <Grid>
                                        <small className='text-danger'>{messages['realtimemaps_vicinitytool_error_point_in_map']}</small>
                                    </Grid>
                                }
                            </div>
                            <div style={{ marginBottom: 5 }}>

                                <TagsManage
                                    onlyTags={true}
                                    mode="selector"
                                    enableSelectAll={false}
                                    disableUntaggedSelection={true}
                                    height={120}
                                    label={messages['realtimemaps_vicinitytool_tags']}
                                    placeholder={messages['realtimemaps_vicinitytool_search_available_tags']}
                                    value={group || []}
                                    onChange={(values) => {
                                        let newValues = [...values]
                                        if (group && newValues && newValues.length > 0 && group.length < newValues.length) {
                                            newValues[newValues.length - 1] = {
                                                ...newValues[newValues.length - 1],
                                            }
                                        }
                                        dispatch(vicinityToolSetField({ group: newValues }))
                                    }}
                                    menuStyle={{ maxHeight: '280px', maxWidth: '300px' }}
                                    isVisiblePill={true}

                                />
                            </div>
                            <div className="vicinity-tool-calendar-container">
                                <Grid>
                                    <label className="label-gtc-rc">
                                        {messages['realtimemaps_vicinitytool_range']}
                                        <span className="text-danger" style={{ marginRight: 2 }}> *</span>
                                        ({messages['realtimemaps_vicinitytool_max_12_hours']})
                                    </label>
                                </Grid>
                                <TimeFrame
                                    isRequired
                                    filterSwitch={false}
                                    {...timeFrame}
                                    placeholder={messages['realtimemaps_vicinitytool_select']}
                                    requiredMessage={messages["required_field"]}
                                    customRangeDate={30}
                                    maxDate={moment().endOf('day').toDate()}
                                    dateFormat={dateformat || 'Y/m/d'}
                                    openDateRangePickerModalAutomatically={false}
                                    advancedFilter={false}
                                    className="vicinity-tool-calendar"
                                />
                            </div>
                            {
                                ((shape?.type === TypeObjectMap.Circle) || shape?.type === TypeObjectMap.Square) &&
                                <div>
                                    <Grid>
                                        <InputRadius
                                            value={radius || defaulRadius}
                                            onChange={onChangeRadius}
                                            options={GeofenceRadiusValues}
                                            isSquare={(shape?.type === TypeObjectMap.Square) || false}
                                            maximunArea={shape?.type === TypeObjectMap.Circle ? maximunAreaCircle : maximunAreaSquare}
                                        >
                                        </InputRadius>
                                    </Grid>
                                </div>
                            }
                        </>
                    }
                </Form>
            </div>
        </div>
    )
}

export default VicinityToolSettings